import React, { useState, useCallback, useEffect } from 'react';
import { Slider, Badge, Button, Grid, Box, Divider, Stack, Typography, Tooltip } from '@mui/material';
import { FaCircleChevronRight, FaCircleChevronLeft, FaCalendarDays } from "react-icons/fa6";
import Cropper from 'react-easy-crop';
import logoLoader from '../../extra/camera-small.png'

const CompareMonth = ({ months }) => {

    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [loading, setLoading] = useState(false);

    return (<>
        <Box className={'cambg'} position={'relative'} zIndex={10} sx={{ height: '100vh' }}>
            <Box sx={{ display: 'flex', flex: '1 1 ' }}>
                {months.map((month, i) => (
                    <Box
                        className="crop-container"
                        sx={{ position: 'relative', height: 'calc(100vh - 100px)', width: 1, borderRight: '1px solid white', background: 'black' }}
                    >
                        <Typography title={month?.error} sx={{ position: 'relative', zIndex: 999999, color: 'white', p: 1 }}>{month.month}</Typography>
                        <Cropper
                            crop={crop}
                            image={month.images?.[0] || logoLoader}
                            zoom={zoom}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            cropShape="rectangle"
                            onMediaLoaded={() => setLoading(false)}
                            maxZoom={8}
                            objectFit="vertical-cover"

                        />

                    </Box>
                ))}
            </Box>
            <Box sx={{ height: "40px", width: 200, mx: 'auto', textAlign: 'center', py: 0.5 }}>
                <Slider
                    value={zoom}
                    onChange={(_, newValue) => setZoom(newValue)}
                    step={0.1}
                    min={2}
                    max={8}
                    aria-labelledby="zoom-slider"
                    sx={{ color: '#ffd80c' }}
                />
            </Box>
        </Box>
    </>
    )
}
export default CompareMonth
